export default {
  route: {
    dashboard: '系统主页',
    profile: '个人中心'
  },
  navbar: {
    setting: '系统设置',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    docs: '项目文档',
    theme: '换肤',
    size: '布局大小',
    deleteCache: '清除缓存'
  },
  login: {
    title: 'yelink-iot 系统登录',
    logIn: '立即登录',
    username: '账号',
    password: '密码',
    code: '验证码',
    ortherLoginType: '其他登录方式',
    chooseToSignIn: '选择以下账号登录：',
    type: {
      up: '账号密码登录',
      social: '第三方账号登录'
    }
  },
  documentation: {
    documentation: '项目文档',
    github: '项目地址'
  },
  table: {
    sync: '同步',
    user: {
      username: '用户名',
      password: '密码',
      sex: '性别',
      email: '邮箱',
      organizationId: '组织ID',
      organization: '组织',
      telephone: '电话',
      role: '角色',
      mobile: '电话',
      status: '状态',
      createTime: '创建时间',
      modifyTime: '修改时间',
      lastLoginTime: '最后登录时间',
      desc: '个人描述',
      oldPassword: '旧密码',
      newPassword: '新密码',
      confirmPassword: '再次确认',
      social: '第三方账号'
    },
    role: {
      roleName: '角色名称',
      remark: '角色描述',
      createTime: '创建时间',
      perms: '角色权限'
    },
    menu: {
      parentId: '上级菜单',
      menuName: '名称',
      type: '类型',
      icon: '图标',
      component: '组件',
      path: 'URL',
      orderNum: '排序',
      perms: '权限',
      hidden: '可见性'
    },
    dept: {
      deptName: '部门名称',
      parentId: '上级部门',
      orderNum: '排序'
    },
    organization: {
      organizationName: '组织名称',
      organizationId: '组织ID',
      displayName: '展示名称',
      fqdn: '边缘API网关域名',
      organizationAddr: '组织地址',
      organizationPhone: '组织电话',
      createdAt: '创建时间',
      description: '描述',
      loginType: '认证方式'
    },
    systemLog: {
      username: '操作人',
      operation: '操作描述',
      createTime: '操作时间',
      time: '耗时',
      method: '操作方法',
      params: '方法参数',
      ip: 'IP',
      location: '操作地点'
    },
    loginLog: {
      username: '用户名',
      loginTime: '登录时间',
      ip: 'IP',
      location: '登录地点',
      system: '登录系统',
      browser: '浏览器'
    },
    gen: {
      config: {
        author: '作者名称',
        basePackage: '基础包名',
        entityPackage: 'entity包名',
        mapperPackage: 'mapper包名',
        mapperXmlPackage: 'mapperXml包名',
        servicePackage: 'service包名',
        serviceImplPackage: 'serviceImpl包名',
        controllerPackage: 'controller包名',
        isTrim: '是否去除表前缀',
        trimValue: '表前缀'
      },
      generate: {
        tableName: '表名',
        remark: '备注',
        dataRows: '数据量（行）',
        createTime: '创建时间',
        updateTime: '更新时间'
      }
    },
    eximport: {
      field1: '字段1',
      field2: '字段2',
      field3: '字段3',
      createTime: '导入时间'
    },
    routeUser: {
      tips: '网关管理用户账号列表，权限分为普通用户（user）和管理用户（admin）',
      username: '用户名',
      perm: '权限',
      createTime: '创建时间',
      password: '密码'
    },
    routeLog: {
      tips: '网关转发请求日志，这些为未被限流或黑名单规则拦截的请求',
      ip: '请求IP',
      targetServer: '目标服务',
      requestMethod: '请求方法',
      requestTime: '请求时间',
      requestUri: '请求URI',
      targetUri: '目标URI',
      location: '请求地址'
    },
    rateLimitRule: {
      tips: '定义网关限流规则，不符合规则的请求将被拦截，拦截记录可以通过限流日志查看',
      requestUri: '请求URI',
      requestMethod: '请求方法',
      limitFrom: '限制时间起',
      allTheTime: '所有时间',
      limitTo: '限制时间止',
      count: '请求次数',
      period: '时间周期（秒）',
      createTime: '创建时间',
      nst: '不支持通配符',
      status: '规则状态',
      timeLimit: '时间限制',
      timeRange: '时间范围'
    },
    rateLimitLog: {
      tips: '展示被限流规则拦截的请求日志',
      requestUri: '请求URI',
      requestMethod: '请求方法',
      createTime: '请求时间',
      ip: '请求IP',
      location: '请求地址'
    },
    blackList: {
      tips: '定义网关请求黑名单',
      requestUri: '请求URI',
      requestMethod: '请求方法',
      createTime: '创建时间',
      ip: '请求IP',
      location: '请求地址',
      allIp: '所有IP',
      limitFrom: '限制时间起',
      allTheTime: '所有时间',
      limitTo: '限制时间止',
      status: '规则状态',
      st: '支持通配符',
      timeLimit: '时间限制',
      timeRange: '时间范围'
    },
    blockLog: {
      tips: '展示被限流规则拦截的请求日志',
      requestUri: '请求URI',
      requestMethod: '请求方法',
      createTime: '请求时间',
      ip: '请求IP',
      location: '请求地址'
    },
    routeLogin: {
      needLogin: '网关管理模块操作需要认证，',
      toLogin: '点击认证',
      tips: '该模块功能需要预先开启网关增强，开启方法请参考文档：',
      title: 'yelink-iot 网关管理认证',
      login: '认证'
    },
    product: {
      productName: '产品名称',
      productKey: 'ProductKey',
      productCategory: '品类',
      productDesc: '产品描述',
      netType: '连网方式',
      nodeType: '节点类型',
      dataType: '数据类型',
      authType: '认证方式',
      createProduct: '创建产品',
      createdAt: '添加时间',
      offlineDetectionTime: '离线检测时间(s)'
    },
    serviceSub: {
      productName: '产品名称',
      productKey: 'ProductKey',
      subType: '订阅类型',
      createdAt: '创建时间',
      consumerName: '消费组名称',
      queueName: '队列名称'
    },
    refresh: '刷新',
    operation: '操作',
    search: '搜索',
    reset: '重置',
    more: '更多操作',
    add: '添加',
    export: '导出',
    import: '导入',
    templateDownload: '模板下载',
    delete: '删除',
    resetPassword: '密码重置',
    openInNewPage: '新页面打开'
  },
  tagsView: {
    refresh: '刷新当前',
    close: '关闭当前',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  system: {
    title: 'yelink-iot'
  },
  tips: {
    usernameShouldNotBeEmpty: '用户名不能为空',
    passwordShouldNotBeEmpty: '密码不能为空',
    switchLanguageSuccess: '切换语言成功',
    loginSuccess: '登录成功',
    loginFail: '登录失败',
    syncSuccess: '同步成功',
    defaultPassword: '用户的默认密码为1234qwer',
    getDataFail: '获取数据失败',
    createSuccess: '新增成功',
    updateSuccess: '修改成功',
    deleteSuccess: '删除成功',
    noDataSelected: '请先选择需要操作的数据',
    confirmDelete: '选中数据将被永久删除, 是否继续？',
    confirmDeleteCache: '是否立即清除用户权限缓存？',
    containCurrentUser: '包含当前登录用户，操作已取消',
    neverLogin: '从未登录过系统',
    nothing: '这家伙很懒，什么都没留下',
    topId: '值为0时表示顶级节点',
    choose: '已选择：',
    chooseNothing: '尚未选择任何图标',
    onlyChooseOne: '只能选择一个节点作为父节点',
    noNodeSelected: '请先选择节点',
    confirmDeleteNode: '选中节点及其子结点将被永久删除, 是否继续？',
    iframeGrant: '用户名：yt 密码：123456',
    notEqual: '两次输入不一致',
    oldPasswordIncorrect: '原密码不正确',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    onlySupportXlsx: '只支持Xlsx类型文件',
    updating: '修改中',
    updateFailed: '修改失败',
    noPermission: '无权限',
    confirmRestPassword: '确定重置所选用户密码？',
    resetPasswordSuccess: '所选用户密码重置已被重置为1234qwer',
    getCodeImageFailed: '获取图形验证码失败',
    tooManyRequest: '获取验证码过于频繁，请稍后再试',
    clientOriginSecret: '该客户端原始密码为：',
    sameRule: '已存在相同的规则',
    createTips: '请在表单中填写相关信息'
  },
  rules: {
    require: '不能为空',
    range1to32: '长度在 1 到 32 个字符',
    range2to10: '长度在 2 到 10 个字符',
    range3to10: '长度在 3 到 10 个字符',
    range3to20: '长度在 3 到 20 个字符',
    range3to32: '长度在 3 到 32 个字符',
    range4to10: '长度在 4 到 10 个字符',
    range4to32: '长度在 4 到 32 个字符',
    range6to20: '长度在 6 到 20 个字符',
    email: '请输入正确的邮箱地址',
    mobile: '请输入合法的手机号',
    telephone: '请输入合法的电话',
    usernameExist: '该用户名已存在',
    emailExist: '该邮箱已存在',
    clientIdExist: '该Client ID已存在',
    roleNameExist: '该角色名称已存在',
    noMoreThan10: '长度不能超过10个字符',
    noMoreThan11: '长度不能超过11个字符',
    noMoreThan20: '长度不能超过20个字符',
    noMoreThan50: '长度不能超过50个字符',
    noMoreThan100: '长度不能超过100个字符',
    invalidInteger: '请输入大于零的整数',
    invalidURL: '不是有效的URL',
    organizationIdExist: '该组织ID已存在'
  },
  common: {
    system: '渊联物联平台',
    desc: {
      a: '基于Spring Boot 2.2.0 & Spring Cloud Hoxton.RELEASE',
      b: '使用Spring Cloud OAuth2统一认证'
    },
    view: '查看',
    tips: '提示',
    clear: '清除',
    confirm: '确定',
    cancel: '取消',
    success: '完成',
    add: '新增',
    create: '立即创建',
    prev: '上一步',
    next: '下一步',
    edit: '修改',
    editDraft: '编辑草稿',
    yes: '是',
    no: '否',
    open: '开启',
    close: '关闭',
    sex: {
      male: '男性',
      female: '女性',
      secret: '保密'
    },
    status: {
      valid: '有效',
      invalid: '禁用'
    },
    menu: {
      menu: '菜单',
      button: '按钮'
    },
    tab: {
      common: '通用类',
      directivity: '指向性',
      solid: '填充类',
      food: '食品类'
    },
    aboutMe: '关于我',
    changeAvatar: '更换头像',
    lastLoginTime: '上次登录时间',
    allProject: '所有项目',
    noDept: '暂无部门',
    noRole: '暂无角色',
    you: '您',
    total: '总数',
    visitTitle: '近十天系统访问记录',
    timeline: '登录时间',
    account: '账号信息',
    password: '个人密码',
    importResult: '导入结果',
    hthz: '后田花子',
    al: '阿里系',
    lm: '脸萌',
    ctc: '点击选择',
    pleaseInputUrl: '请输入URL',
    bind: '绑定',
    unbind: '解绑',
    confirmUnbind: '确定解绑该第三方账号？',
    unbindSuccess: '解绑成功',
    bindSuccess: '绑定成功',
    bindLogin: '绑定并登录',
    signLogin: '注册并登录',
    current: '当前',
    socialAccount: '账号',
    socialTips: '尚未绑定任何系统账户，您可以绑定系统账户或者注册一个新的账户并绑定。',
    bannerTitle: '为开发人员提供一站式服务',
    bannerWord: '为开发人员提供方便的开发插件，帮助开发人员更快地开发和测试应用程序',
    type: '类型',
    video: '视频应用',
    game: '游戏',
    VideoSurveilance: '视频监控',
    AR: 'AR/VR',
    api: 'API',
    sdk: 'SDK',
    MEP: 'MEP',
    Security: '安全',
    blockchain: '区块链',
    smartDevice: '智能设备',
    IOT: '物联网',
    bigdata: '大数据',
    calculate: '计算',
    all: 'All',
    affinity: '架构',
    GPU: 'GPU',
    MEN: 'MEM',
    CPU: 'CPU',
    AI: 'AI',
    industry: '行业',
    Smartpark: '智慧园区',
    supermarket: '智慧商超',
    industrialManufacturing: '工业制造',
    logistics: '交通物流',
    hydroelectricity: '水利',
    games: '游戏竞技',
    openSource: '开源',
    else: '其他',
    appName: '应用名称',
    version: '版本',
    size: '大小',
    provider: '技术服务商',
    contact: '联系方式',
    operation: '操作',
    detail: '详情',
    delete: '删除',
    detect: '检测',
    download: '下载',
    applicationName: '应用名称',
    description: '描述',
    userName: '上传人',
    getCaptcha: '获取验证码',
    inputCaptcha: '请输入验证码',
    choose: '请选择',
    equipmentMarketName: '产品名称或型号',
    name: '名称'
  },
  store: {
    advancedSearch: '高级搜索',
    clearAll: '清空',
    screening: '筛选',
    sortBy: '排序',
    most: '下载量',
    name: '名称',
    score: '评分',
    appPackageInfo: '应用程序基本信息',
    createTime: '创建时间',
    download: '下载',
    comments: '评论',
    message: '消息',
    postComment: '提交评论',
    uploadApp: '上传应用',
    uploadLogo: '上传图标',
    appPackage: '应用程序',
    appName: '应用名称',
    dragPackage: '拖动应用程序包文件到这里或点击上传',
    onlyCsar: '只能上传 docker-compose.yml 文件.且compose版本=v2',
    packageSizeLimit: '文件大小不超过10M',
    appIcon: '应用图标',
    onlyImg: '请上传.jpg或.png格式文件,或者选择默认图标',
    iconSizeLimit: '文件大小不超过2M',
    userName: '用户',
    time: '时间',
    toBeAdded: '待补充'
  },
  promptMessage: {
    operationFailed: '操作失败!',
    modifySuccess: '修改成功!',
    modifyFail: '修改失败!',
    fileNotSupport: '文件格式不支持或内容为空!',
    deleteSuccess: '删除成功!',
    fileNotContent: '文件格式不支持或内容为空!',
    canOnlyUpload: '只能上传 .',
    files: ' 类型文件.',
    uploadPicture: '请上传.jpg或.png格式文件.',
    uploadPackageFile: '请添加需要上传的安装包文件!',
    uploadIconFile: '请上传图标文件或者选择图标!',
    industryEmpty: '行业不能为空',
    affinityEmpty: '架构不能为空',
    typeEmpty: '类型不能为空',
    shortDescEmpty: '描述不能为空',
    completedTest: '您已经完成了测试，请点击查看报告',
    uploadSuccess: '上传成功!',
    uploadFailed: '上传失败!',
    checkName: '验证失败，请重新检查用户名或密码.',
    repeatEnter: '输入信息有误，请重新输入。',
    userResistedSuccess: '用户注册成功!!',
    userResistedFaile: '注册用户失败',
    deletePrompt: '该操作将永久删除应用程序。你想继续吗?',
    prompt: '提示',
    checkUploadProgress: '立即检查上传进度?',
    browserAdvise: '为了部分功能正常使用，我们建议使用Chrom浏览器！',
    userNameIsExists: '用户名已注册，请更换新用户名。',
    phoneNumIsExists: '电话号码已经注册了。',
    subCommentFail: '提交评论失败。',
    getCommentFail: '获取评论失败。',
    getAppFail: '获取App数据失败。',
    getTaskListFail: '获取测试任务失败。',
    getMyAppFail: '获取我的App数据失败。',
    verifyNamePhoneFail: '验证用户名或手机号失败。',
    registerFail: '注册失败。',
    getCaptchaSuccess: '验证码已发送至您的手机，请查收。',
    getCaptchaFail: '获取验证码失败。',
    confirmLogout: '您确定要退出吗?',
    contrastTime: '提交时间不能早于测试结束时间！',
    subCommentFailReason: '评分和评论内容是必须的',
    cannotComment: '您不能评论两次',
    onlyOneFile: '仅支持一个文件，请先移除已有文件！'
  }
}
